import React, {forwardRef, useContext} from "react";

import {View, Text}  from 'react-native'

import {estilos} from '../util/estilos'

import Imagem from '../componentes/Imagem'

import Bloco from '../componentes/Bloco'

import contexto from '../util/contexto'

import {USER_TIPO_PJ, TELA_LOJA} from '../util/constantes'

import Botao from '../componentes/Botao'

import {useNavigation} from '@react-navigation/native'

import * as validacao from '../util/validacao'

import * as util from '../util/util'



const InfosLoja = forwardRef((props, ref) => {

	const {setValorContexto} = useContext(contexto);
	
	const navegacao = new useNavigation();

	

	const verLoja= ()=>{

		console.log("verLoja id_loja="+props.loja.id);
		
		setValorContexto(prevState =>({...prevState, idLoja: props.loja.id}));

		util.setVoltar(util.temConteudo(props.voltarPara)?props.voltarPara:null);

		navegacao.navigate(TELA_LOJA);
	}


    return (
		<View>  
			{props.loja != null?
				(props.detalhado?
					<Bloco>
						<View style={{marginTop:10}}/>  
						<View style={{alignItems:'center'}}>
							<Text style={estilos.rotulo_titulo}>{props.titulo}</Text>
							<View style={{marginTop:10}}/> 
							<Imagem imagem={props.loja.imagem} tamanho={160} redondo={true}/>		
							<View style={{marginTop:10}}/> 
										
							<View style={{alignItems:'center'}}>
								<Text style={estilos.rotulo_titulo}>{props.loja.nome}</Text>	    
							</View>
							
							{props.loja.tipo == USER_TIPO_PJ && 
								<View style={{alignItems:'center'}}>
									<View style={{marginTop:10}}/> 
									<Text style={estilos.rotulo_padrao}>{validacao.formataCnpj(props.loja.cpf_cnpj)}</Text>
								</View>
							}
									
							<View style={{marginTop:10}}/> 

							<Text style={estilos.rotulo_padrao}>{props.loja.email}</Text>
					
							<View style={{marginTop:20}}/> 

							<Botao
								acao={()=>verLoja()}
								texto="Conferir Loja"
								somente_texto={true}/> 
								
							<View style={{marginTop:10}}/>   
						</View>
						{props.children!=null && props.children}
					</Bloco>:
					<Bloco>
						<View style={estilos.grade}>
							<Imagem imagem={props.loja.imagem} tamanho={60} redondo={true}/>
							<View style={[estilos.coluna, {marginLeft:10}]}>	
								<View style={{marginTop:10}}/> 
								<Text style={estilos.rotulo_titulo}>{props.loja.nome}</Text>
								<Text style={estilos.rotulo_padrao}>{props.loja.email}</Text>			
							</View>
						</View>
						{props.children!=null && props.children}
					</Bloco>):
					(<View></View>)
			}
		</View>
	)
});


export default InfosLoja;